import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';

interface UnsavedChangesPopupProps {
    tabsWithChanges: string[];
    onDiscard: () => void;
    onCancel: () => void;
}

const UnsavedChangesPopup: React.FC<UnsavedChangesPopupProps> = ({ 
    tabsWithChanges, 
    onDiscard, 
    onCancel 
}) => {
    return (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-[9999]">
            <div className="bg-white dark:bg-neutral-800 rounded-lg shadow-xl max-w-md w-full mx-4 p-6">
                <div className="flex items-center space-x-3 mb-4">
                    <FontAwesomeIcon 
                        icon={faExclamationTriangle} 
                        className="text-orange-500 text-xl" 
                    />
                    <h3 className="text-lg font-semibold dark:text-neutral-100">
                        Unsaved Changes
                    </h3>
                </div>
                
                <div className="mb-6">
                    <p className="text-neutral-600 dark:text-neutral-300 mb-3">
                        You have unsaved changes in the following tabs:
                    </p>
                    <ul className="list-disc list-inside text-neutral-700 dark:text-neutral-300 space-y-1">
                        {tabsWithChanges.map(tabName => (
                            <li key={tabName} className="text-sm">
                                {tabName}
                            </li>
                        ))}
                    </ul>
                    <p className="text-neutral-600 dark:text-neutral-300 mt-3">
                        Are you sure you want to close without saving? Your changes will be lost.
                    </p>
                </div>
                
                <div className="flex space-x-3 justify-end">
                    <button
                        onClick={onCancel}
                        className="px-4 py-2 text-neutral-600 dark:text-neutral-300 hover:text-neutral-800 dark:hover:text-neutral-100 transition-colors duration-200"
                    >
                        Cancel
                    </button>
                    <button
                        onClick={onDiscard}
                        className="px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors duration-200"
                    >
                        Discard Changes
                    </button>
                </div>
            </div>
        </div>
    );
};

export default UnsavedChangesPopup;